import React, { FunctionComponent } from 'react';
import { Row, Column, ColoredButton, cls } from '../../index';
import { HEADER_COMPOUND } from '../utils/constants';
export interface IHeaderProps {
    disabled?: boolean;
    onClick?: () => void;
    onFocus?: any;
    image?: string;
    textBack?: string;
    icon?: string;
    align?: 'right' | 'left';
    colorKey?: string;
}

export const HeaderCompound: FunctionComponent<IHeaderProps> = ({
    disabled,
    onClick,
    image,
    textBack = '',
    icon,
    align = 'right',
    onFocus,
    colorKey
}) => {
    return (
        <Row className={cls(`${HEADER_COMPOUND}-row`)}>
            <Column lg={3} className={cls(`${HEADER_COMPOUND}-header-logo`)}>
                {!disabled && <img src={image} alt="claroTv logo" />}
                {
                    align === 'left' && textBack && icon &&
                    <ColoredButton
                        onClick={onClick}
                        children={textBack}
                        color="yellow"
                        imgSrc={icon}
                        onFocus={onFocus}
                    />
                }
            </Column>
            <Column offset={7} lg={2} className={cls(`${HEADER_COMPOUND}-header-buttons`)}>
                {
                    align === 'right' && textBack && icon &&
                    <ColoredButton
                        onClick={onClick}
                        children={textBack}
                        color="yellow"
                        imgSrc={icon}
                        onFocus={onFocus}
                        classSizeHotkey='large'
                        colorKey={colorKey}
                    />
                }
            </Column>
        </Row>
    );
};


// WEBPACK FOOTER //
// ./src/packages/components/lib/HeaderCompound/index.tsx